/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PublicExternalLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PublicExternalLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PublicExternalLinkApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PublicExternalLink);
  }
}(this, function(ApiClient, PublicExternalLink) {
  'use strict';

  /**
   * PublicExternalLink service.
   * @module api/PublicExternalLinkApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PublicExternalLinkApi. 
   * @alias module:api/PublicExternalLinkApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the publicExternalLinkAddAllPut operation.
     * @callback module:api/PublicExternalLinkApi~publicExternalLinkAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PublicExternalLink>} body 
     * @param {module:api/PublicExternalLinkApi~publicExternalLinkAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.publicExternalLinkAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling publicExternalLinkAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling publicExternalLinkAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/PublicExternalLink/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publicExternalLinkAddAndLoadPut operation.
     * @callback module:api/PublicExternalLinkApi~publicExternalLinkAddAndLoadPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PublicExternalLink} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAndLoad
     * @param {String} _4SAPIAppID 
     * @param {module:model/PublicExternalLink} body 
     * @param {module:api/PublicExternalLinkApi~publicExternalLinkAddAndLoadPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PublicExternalLink}
     */
    this.publicExternalLinkAddAndLoadPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling publicExternalLinkAddAndLoadPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling publicExternalLinkAddAndLoadPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = PublicExternalLink;

      return this.apiClient.callApi(
        '/PublicExternalLink/addAndLoad', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publicExternalLinkDeleteGet operation.
     * @callback module:api/PublicExternalLinkApi~publicExternalLinkDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/PublicExternalLinkApi~publicExternalLinkDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.publicExternalLinkDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling publicExternalLinkDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling publicExternalLinkDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PublicExternalLink/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publicExternalLinkEditPut operation.
     * @callback module:api/PublicExternalLinkApi~publicExternalLinkEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/PublicExternalLink} body 
     * @param {module:api/PublicExternalLinkApi~publicExternalLinkEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.publicExternalLinkEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling publicExternalLinkEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling publicExternalLinkEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PublicExternalLink/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publicExternalLinkLoadAllGet operation.
     * @callback module:api/PublicExternalLinkApi~publicExternalLinkLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PublicExternalLink>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/PublicExternalLinkApi~publicExternalLinkLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PublicExternalLink>}
     */
    this.publicExternalLinkLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling publicExternalLinkLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PublicExternalLink];

      return this.apiClient.callApi(
        '/PublicExternalLink/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publicExternalLinkLoadByIdentifierGuidGet operation.
     * @callback module:api/PublicExternalLinkApi~publicExternalLinkLoadByIdentifierGuidGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PublicExternalLink} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadByIdentifierGuid
     * @param {String} _4SAPIAppID 
     * @param {String} identifierGuid 
     * @param {module:api/PublicExternalLinkApi~publicExternalLinkLoadByIdentifierGuidGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PublicExternalLink}
     */
    this.publicExternalLinkLoadByIdentifierGuidGet = function(_4SAPIAppID, identifierGuid, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling publicExternalLinkLoadByIdentifierGuidGet";
      }

      // verify the required parameter 'identifierGuid' is set
      if (identifierGuid == undefined || identifierGuid == null) {
        throw "Missing the required parameter 'identifierGuid' when calling publicExternalLinkLoadByIdentifierGuidGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'identifierGuid': identifierGuid
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = PublicExternalLink;

      return this.apiClient.callApi(
        '/PublicExternalLink/loadByIdentifierGuid', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publicExternalLinkLoadManyPut operation.
     * @callback module:api/PublicExternalLinkApi~publicExternalLinkLoadManyPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PublicExternalLink>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadMany
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/PublicExternalLinkApi~publicExternalLinkLoadManyPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PublicExternalLink>}
     */
    this.publicExternalLinkLoadManyPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling publicExternalLinkLoadManyPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling publicExternalLinkLoadManyPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PublicExternalLink];

      return this.apiClient.callApi(
        '/PublicExternalLink/loadMany', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the publicExternalLinkLoadSatisfactionFeedbackLinkGet operation.
     * @callback module:api/PublicExternalLinkApi~publicExternalLinkLoadSatisfactionFeedbackLinkGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadSatisfactionFeedbackLink
     * @param {String} _4SAPIAppID 
     * @param {module:api/PublicExternalLinkApi~publicExternalLinkLoadSatisfactionFeedbackLinkGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.publicExternalLinkLoadSatisfactionFeedbackLinkGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling publicExternalLinkLoadSatisfactionFeedbackLinkGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/PublicExternalLink/loadSatisfactionFeedbackLink', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
